import { AnimatePresence, motion } from 'framer-motion';

import { cn } from '@/utils/styles';

interface IInputFieldErrorProps {
	errorMessage?: string | null;
	className?: string;
}

function InputFieldError({ errorMessage, className }: IInputFieldErrorProps) {
	return (
		<AnimatePresence
			mode="wait"
			onExitComplete={() => null}
		>
			{errorMessage && (
				<motion.p
					layout
					initial={{ height: 0, opacity: 0, marginTop: 0 }}
					animate={{ height: 'auto', opacity: 1, marginTop: 12 }}
					exit={{ height: 0, opacity: 0, marginTop: 0 }}
					transition={{ duration: 0.2, ease: 'easeInOut' }}
					className={cn('text-sm text-red-500', !!className && className)}
				>
					{errorMessage}
				</motion.p>
			)}
		</AnimatePresence>
	);
}

export default InputFieldError;
